export const STORAGE_NAME_DEBUG_MODE = 'debugMode';
export const STORAGE_NAME_DEBUG_BOOKING_STATE = 'debug_bookingState';
